import { render, staticRenderFns } from "./promotion-copy-dialog.vue?vue&type=template&id=70d25a47&scoped=true"
import script from "./promotion-copy-dialog.vue?vue&type=script&lang=js"
export * from "./promotion-copy-dialog.vue?vue&type=script&lang=js"
import style0 from "./promotion-copy-dialog.vue?vue&type=style&index=0&id=70d25a47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d25a47",
  null
  
)

export default component.exports